:host {
  .hide {
    display: none !important;
  }

  .report-abuse {
    width: 100%;
    height: auto;
    background: transparent;
    color: #fff;
    border-radius: 8px 10px 10px 8px;
    padding: 0px 10px 30px;
    box-sizing: border-box;

    &.full {
      background: transparent;
      margin: auto;
    }

    .error-message {
      background: rgb(163, 59, 59);
      margin-top: 16px;
      padding: 5px 10px;
      border-radius: 10px;
      width: fit-content;
    }

    &__subtitle {
      width: 100%;
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
      padding-left: 0;
      padding-bottom: 8px;
    }

    &-sent__subtitle {
      width: 100%;
      font-size: 22px;
      line-height: 30px;
      padding-left: 0px;
      padding-bottom: 24px;
      padding-top: 30px;
    }

    &__text {
      width: 100%;
      font-size: 18px;
      line-height: 24px;
      padding-left: 0px;
      padding-bottom: 24px;
      color: #ffffffc2;
    }

    .text-center {
      text-align: center;
    }

    &__type {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      align-content: center;
    }

    &__radio {
      width: 100%;
      display: flex;
      font-size: 16px;
      line-height: 34px;
      padding-left: 0;
      border-bottom: 1px solid #ffffff29;

      input,
      span {
        font-size: 16px;
        line-height: 28px;
      }
    }

    &__disclaimer {
      margin-top: 16px;
      input,
      span {
        font-size: 14px;
        line-height: 28px;
      }
      .report-abuse__type {
        align-items: baseline;
      }
    }

    .input-group {
      margin-top: 16px;
      label {
        font-size: 16px;
      }
      select,
      input,
      textarea {
        margin-top: 8px;
        box-sizing: border-box;
        width: 100%;
        border: 1px solid var(--divider);
        border-radius: 4px;
        padding: 15px;
        font-size: 15px;
        color: var(--font-secondary);
        font-family: Roboto, sans-serif;
        background: var(--bg-primary);

        &:focus {
          outline: none;
        }
      }
      select:disabled,
      input:disabled,
      textarea:disabled {
        opacity: 0.6;
        cursor: unset;
      }
      select {
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQuMDM3MTQgNi4yOTEwMkM0LjI0MDc0IDYuMjkxMjcgNC40MzQ1OSA2LjIwMzgyIDQuNTY5MTQgNi4wNTEwMkw3LjU4NzkxIDIuNjIwMjVDNy43Mjc2NSAyLjQ2ODYzIDcuNzc0MzEgMi4yNTMyMiA3LjcwOTg0IDIuMDU3MzdDNy42NDUzNiAxLjg2MTUzIDcuNDc5ODYgMS43MTU5NiA3LjI3NzM5IDEuNjc3MDFDNy4wNzQ5MSAxLjYzODA2IDYuODY3MjIgMS43MTE4MyA2LjczNDY4IDEuODY5NzhMNC4wOTQ5OSA0Ljg2OTc4QzQuMDgwMzggNC44ODY0NSA0LjA1OTMgNC44OTYgNC4wMzcxNCA0Ljg5NkM0LjAxNDk4IDQuODk2IDMuOTkzOSA0Ljg4NjQ1IDMuOTc5MyA0Ljg2OTc4TDEuMzM5NiAxLjg2OTE3QzEuMjA3MDcgMS43MTEyMiAwLjk5OTM3NyAxLjYzNzQ1IDAuNzk2OSAxLjY3NjRDMC41OTQ0MjMgMS43MTUzNSAwLjQyODkyNiAxLjg2MDkxIDAuMzY0NDQ5IDIuMDU2NzZDMC4yOTk5NzMgMi4yNTI2MSAwLjM0NjYzMyAyLjQ2ODAyIDAuNDg2MzczIDIuNjE5NjNMMy41MDQyMiA2LjA0OTc4QzMuNjM5IDYuMjAyOTYgMy44MzMxMSA2LjI5MDgyIDQuMDM3MTQgNi4yOTEwMloiIGZpbGw9IiMwMDk4RkYiLz4KPG1hc2sgaWQ9Im1hc2swXzQzMzZfMTcwMTUiIHN0eWxlPSJtYXNrLXR5cGU6bHVtaW5hbmNlIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIxIiB3aWR0aD0iOCIgaGVpZ2h0PSI2Ij4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjAzNzE0IDYuMjkxMDJDNC4yNDA3NCA2LjI5MTI3IDQuNDM0NTkgNi4yMDM4MiA0LjU2OTE0IDYuMDUxMDJMNy41ODc5MSAyLjYyMDI1QzcuNzI3NjUgMi40Njg2MyA3Ljc3NDMxIDIuMjUzMjIgNy43MDk4NCAyLjA1NzM3QzcuNjQ1MzYgMS44NjE1MyA3LjQ3OTg2IDEuNzE1OTYgNy4yNzczOSAxLjY3NzAxQzcuMDc0OTEgMS42MzgwNiA2Ljg2NzIyIDEuNzExODMgNi43MzQ2OCAxLjg2OTc4TDQuMDk0OTkgNC44Njk3OEM0LjA4MDM4IDQuODg2NDUgNC4wNTkzIDQuODk2IDQuMDM3MTQgNC44OTZDNC4wMTQ5OCA0Ljg5NiAzLjk5MzkgNC44ODY0NSAzLjk3OTMgNC44Njk3OEwxLjMzOTYgMS44NjkxN0MxLjIwNzA3IDEuNzExMjIgMC45OTkzNzcgMS42Mzc0NSAwLjc5NjkgMS42NzY0QzAuNTk0NDIzIDEuNzE1MzUgMC40Mjg5MjYgMS44NjA5MSAwLjM2NDQ0OSAyLjA1Njc2QzAuMjk5OTczIDIuMjUyNjEgMC4zNDY2MzMgMi40NjgwMiAwLjQ4NjM3MyAyLjYxOTYzTDMuNTA0MjIgNi4wNDk3OEMzLjYzOSA2LjIwMjk2IDMuODMzMTEgNi4yOTA4MiA0LjAzNzE0IDYuMjkxMDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfNDMzNl8xNzAxNSkiPgo8L2c+Cjwvc3ZnPgo=');
        background-repeat: no-repeat, repeat;
        background-position:
          right 0.7em top 50%,
          0 0;
        background-size:
          12px auto,
          100%;
        cursor: pointer;
      }
    }

    &__comment {
      border: none;
      padding: 10px 40px 10px 20px;
      height: 100px;
      line-height: 16px;
      resize: none;

      &:focus {
        outline: none;
      }
    }

    .margin-right-10 {
      margin-right: 10px;
    }

    .g-recaptcha {
      margin-top: 32px;
      margin-bottom: 16px;
    }

    .report-sent__img {
      margin: 20px auto;
      display: block;
      height: 150px;
    }

    &__actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    .button__primary {
      width: 100%;
      background-color: #0098ff;
      color: white;
      text-transform: uppercase;
      padding: 12px 50px;
      border-radius: 6px;
      border: none;
      cursor: pointer;
      white-space: nowrap;
      transition: all 0.3s;
    }

    .button__primary:hover {
      transition: all 0.3s;
      background-color: #0089e6;
    }

    .button__primary {
      &.disabled {
        background-color: #7fcbff;
        color: #fff;
        cursor: not-allowed;
      }
    }

    .button__cancel {
      background-color: var(--bg-secondary);
      color: #666666;
      text-transform: uppercase;
      padding: 10px 13px 8px;
      border-radius: 2px;
      border: none;
      cursor: pointer;
      white-space: nowrap;
      transition: all 0.3s;
    }

    .button__cancel:hover {
      transition: all 0.3s;
      background-color: var(--bg-secondary);
    }
  }
}
